import apiPaths from '../api-paths';

export default {
  list({ query = '' }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/declarations/${ query }`);
  },
  downloadJpkFaXml({ data }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/declarations/jpk-fa/download/xml`, data);
  },

  generateDeclarationCorrect({ declarationId, declarationType }) {
    return axios.post(
      `${ apiPaths.BOOKKEEPING }/generateDeclarationCorrect/${ declarationId }`,
      { declaration_type: declarationType },
    );
  },
  generateDeclaration({ data }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/generateDeclaration`, data);

  },


};
